export enum ParticleType {
	SIMPLE = 'simple',
	PARALLAX = 'parallax',
	HOME = 'home',
	SPACES_GRID = 'spaces_grid',
	SCREENS_GRID = 'screens_grid'
}

export enum ParticleFieldType {
	SIMPLE = 'simple',
	HOME = 'home',
	SCREENS_GRID = 'screens_grid',
	SPACES_GRID = 'spaces_grid'
}

export enum LookupType {
	CIRCLE = 'circle',
	SINE = 'sine',
	ICON = 'icon',
	ICON2 = 'icon2',
	TRI = 'tri',
	RECT = 'rect'
}

export enum RepellType {
	BOUNDARY = 'boundary',
	PUSH = 'push',
	POSITION = 'position',
	VECTOR = 'vector'
}

export enum AttractType {
	DIRECT,
	ORBIT
}

export enum ParticleLayoutType {
	GRID = 'grid',
	RANDOM = 'random',
	IMAGE_PIXEL_DATA = 'image_pixel_data',
	IMAGE_PIXEL_DATA_2 = 'image_pixel_data_2',
	IMAGE_PIXEL_DATA_HEAD = 'image_pixel_data_head',
	TARGET = '',
	PERSPECTIVE = 'perspective',
	ISOMETRIC = 'isometric'
}

export enum ParticleBehaviourTagType {
	//CORE TYPES:
	TINT = 'tint',
	TEXTURE = 'texture',
	POSITION = 'position', //Default position that partcile will move to (can be overidden by the strong attract/repell/path behaviours)
	//ADVANCED TYPES:
	PROGRESS_PARALLAX = 'progress_parallax', //Progress trough scene or timeline and set element position
	MOUSE_PARALLAX = 'mouse_parallax', //Mouse (or accelerometer movement effects mouse)
	PROGRESS_PROPERTIES = 'progress_properties', //Effect particle scale/alpha/rotation based on progress
	ATTRACT = 'attract', //Atract to a object or mouse (Including defaul resting position)
	REPELL = 'repell', //Repell around a point (Mouse of object)
	PATH = 'path', //Orbit or
	EMIT = 'emit', //Emit child particles randomly
	TRAIL = 'trail', //Emit trail type partciles
	LAMP = 'lamp' //Set particles alha/tint based on proxy to target (mouse or object)
}

export enum HomeParticleStateType {
	SPACES = 'spaces',
	SYSTEMS = 'systems',

	OPENING = 'opening',
	OPENING_HOVER = 'opening_hover',
	BLACK_HOLE_FOLLOW = 'black_hole_follow',

	//New states:
	HOME_ICON = 'HOME_ICON',
	SCREENS_FRAME = 'SCREENS_FRAME',
	SCREENS_SHAPE = 'SCREENS_SHAPE',
	SPACES_BOX = 'SPACES_BOX',

	//PROBABLY NOT USED ANY MORE
	HOME = 'home',
	HOME_SCREENS = 'home_screens',
	HOME_SPACES = 'home_spaces',

	SPACES_ACTIVE = 'spaces_active',
	SCREENS_ACTIVE = 'screens_active'
}

export enum ParticleSceneType {
	ICON = 'ICON',
	SPACES = 'SPACES',
	SCREENS = 'SCREENS',
	SYSTEMS = 'SYSTEMS',
	TRANSITION = 'TRANSIION'
}
